import React from 'react'
import styles from "./style.css"
import {
    Container,
    Grid,
    TextField,
    Typography,
    Select,
    MenuItem,
    FormControl,
    InputLabel,
    Button,
  } from "@mui/material";
const NewsLetter = () => {
  return (
    <Container>
    <div className="newsLetterSection">
    <Grid container spacing={1} style={{alignItems:"center"}}>
            <Grid item xs={12} md={6} >
                <h3 className="headingThree">Get Updates And Stay Connected -Subscribe To Our Newsletter</h3>
                </Grid>
                <Grid item xs={12} md={6} >
                    <div  className='textButtonField'>
                <TextField
                      hiddenLabel
                      id="filled-hidden-label-small"
                      placeholder="Email"
                      variant="filled"
                      size="small"
                      className="inputFieldnews phoneFieldd"
                    />
                         <Button variant="contained"  className="submitBtnNewsLetter">
                  Send
                </Button>
                </div>
                </Grid>
                </Grid>
    </div>
    </Container>
  )
}

export default NewsLetter